import { render } from "./matching-card.vue?vue&type=template&id=41ed3f74&scoped=true&ts=true"
import script from "./matching-card.vue?vue&type=script&lang=ts"
export * from "./matching-card.vue?vue&type=script&lang=ts"

import "./matching-card.vue?vue&type=style&index=0&id=41ed3f74&lang=scss&scoped=true"
import "./matching-card.vue?vue&type=style&index=1&id=41ed3f74&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ed3f74"]])

export default __exports__